<template>
  <div class="containers">
    <SectionHeader>
      <template v-slot:breadcrumbs>
        <BreadCrumbs
          :items="[
            { text: $t('notifications.many'), name: 'all_notifications' },
            { text: $t('notifications.editChannel') },
          ]"
        />
      </template>
    </SectionHeader>

    <div class="body-content">
      <div class="entries-wrap">
        <div class="content-wrap">
          <header class="content-header cf">
            <h3>{{ $t('notifications.editChannel') }}</h3>
          </header>
          <div class="content-body">
            <Form v-model="notification_channel" @submit="updateChannel" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Form from '@/views/notifications/channels/Form.vue'

import BreadCrumbs from '@/components/BreadCrumbs'
import SectionHeader from '@/components/SectionHeader'

import notificationChannelsApi from '@/api/notificationChannels'

export default {
  name: 'new_notification_channel',
  inject: ['companyUser'],
  components: { BreadCrumbs, SectionHeader, Form },
  data: () => ({
    notification_channel: {},
  }),
  methods: {
    updateChannel: async function (channel) {
      const updatedNotificationChannel = await notificationChannelsApi.update(channel.uuid, channel)

      if (updatedNotificationChannel) {
        await this.$router.push('/notifications')
      }
    },
  },
  async mounted() {
    this.notification_channel = await notificationChannelsApi.get(this.$route.params.uuid)
  },
}
</script>

<style lang="scss"></style>
